/**
 * WordPress dependencies
 */
import { Path, SVG } from '@wordpress/primitives';

const lineSolid = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M5 11.25h14v1.5H5z" />
	</SVG>
);

export default lineSolid;
